import Header from "./Header";
import SidebarIcons from "./SidebarIcons";
import Sidebar from "./Sidebar";
import { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import dashlogo from "../assets/img/dashbarlogo.png";
// import downloadlogo from "../assets/img/downicon.png";
import {
  useNavigate,
  useParams,
  generatePath,
  useLocation,
} from "react-router-dom";
// import { IconButton } from "@mui/material";
import searchIcon from "../assets/img/searchIcon.png";
import actionSearchIcon from "../assets/img/actionSearchIcon.png";
import actionUpdateIcon from "../assets/img/actionUpdateIcon.png";
import downloadIcon from "../assets/img/excleExport.png";
import DynamicTable from "./common/DynamicTable";
import closeicon from "../assets/img/closeicon.png";
import UpdateActionPopUp from "./common/UpdateActionPopUp";
import useGetClientId from "../hooks/useGetClientId";
import StatusPill from "./common/StatusPill";
import Toaster from "./common/Toaster";
import http from "../api/server";
import DatePicker from "react-multi-date-picker";
import Toolbar from "react-multi-date-picker/plugins/toolbar";
import AutocompleteInput from "./common/AutocompleteInput";
import Tooltip from "@mui/material/Tooltip";

import {
  GET_ACTION_DETAILS,
  // GET_PROPERTY_INFO_WITH_MASTER,
  GET_PROPERTIES_LIST,
  DOWNLOAD_EXCEL_FILE,
} from "../api/apiPath";
import LoadingComponent from "./common/LoadingComponent";

const ActionRemediation = () => {
  const { clientNameParam } = useParams();
  const location = useLocation();
  const STORAGE_KEY = "toolbarValue";
  const [loading, setLoading] = useState(true);
  const clientObj = useGetClientId();
  const [showUpdateModal, setShowUpdateModal] = useState(false);
  const [dash, setDash] = useState("");
  const [propertiesList, setPropertiesList] = useState([]);
  const [flattentedProperties, setFlattenedProperties] = useState([]);
  const [buildingNameList, setBuildingNameList] = useState([]);
  const [actionIdList, setActionidList] = useState([]);
  const [dateRange, setDateRange] = useState([null, null]);
  const [selectedIds, setSelectedIds] = useState([]);
  const [selectedRows, setSelectedRows] = useState([]);
  const [selectedSite, setSelectedSite] = useState(null);

  const navigate = useNavigate();

  const gotoDashBoard = (rowData, field) => {
    let pathTemplate;

    if (field === "view") {
      pathTemplate = "/client/:clientNameParam/viewAction";
    } else {
      pathTemplate = "/client/:clientNameParam/viewAction";
    }

    const params = {
      clientNameParam: clientNameParam,
    };

    const fullPath = generatePath(pathTemplate, params);

    navigate(fullPath, {
      state: {
        selectedRow: rowData,
      },
    });
  };

  const { userObj } = useSelector((state) => state.user);
  const [hideSidebar, setHideSidebar] = useState(false);
  const [rows, setRows] = useState([]);
  const [toastData, setToastData] = useState({
    toastShow: false,
    toastType: "",
    toastString: "",
  });
  const closeButton = () => {
    setToastData({
      toastShow: false,
      toastData: "",
      toastType: "",
    });
  };

  useEffect(() => {
    if (!userObj || !userObj?.token) {
      navigate(
        generatePath("/client/:clientNameParam", {
          clientNameParam,
        }),
        { replace: true, state: { from: "/ClientBranding" } },
      );
    }
  }, [userObj, navigate]);

  useEffect(() => {
    if (!selectedIds.length) {
      setSelectedRows([]);
      return;
    }

    const mapped = rows.filter((row) => selectedIds.includes(row.id));

    setSelectedRows(mapped);
  }, [selectedIds, rows]);

  const tableColumns = [
    {
      field: "Actions",
      headerName: "Actions",
      width: 120,
      height: 50,
      headerClassName: "super-app-theme--header",
      editable: false,
      sortable: false,
      filterable: false,
      type: "string",
      minWidth: 120,
      flex: 1,
      renderCell: (params) => {
        return (
          <>
            <i
              className="fa-solid fa-eye fa-lg"
              title="View"
              style={{ cursor: "pointer", justifyItems: "center" }}
              //
              onClick={() => {
                localStorage.setItem(STORAGE_KEY, JSON.stringify(toolbar));
                gotoDashBoard(params.row, "view");
              }}
            ></i>
          </>
        );
      },
      renderHeader: () => (
        <span style={{ display: "flex", alignItems: "center" }}>
          <span className="personalFont">Actions</span>

          <i
            className="bi bi-info-circle"
            style={{
              fontSize: "0.9rem",
              marginLeft: "5px",
              cursor: "pointer",
            }}
            title="Click the eye icon for each item ti view action details."
          ></i>
        </span>
      ),
    },
    {
      field: "siteName",
      height: 50,
      minWidth: 200,
      headerName: "SITE NAME",
      headerClassName: "super-app-theme--header",
      editable: false,
      sortable: true,
      flex: 1,
      type: "string",
    },
    {
      field: "buildingName",
      height: 50,
      minWidth: 200,
      headerName: "BUILDING NAME",
      headerClassName: "super-app-theme--header",
      editable: false,
      sortable: true,
      flex: 1,
      type: "string",
    },
    {
      field: "doorRefno",
      height: 50,
      minWidth: 250,
      headerName: "DOOR REFERENCE NUMBER",
      headerClassName: "super-app-theme--header",
      editable: false,
      sortable: true,
      flex: 1,
      type: "string",
    },
    {
      field: "address",
      headerName: "ADDRESS",
      width: 150,
      height: 90,
      headerClassName: "super-app-theme--header",
      editable: false,
      type: "string",
      minWidth: 150,
      flex: 1,
    },
    {
      field: "actionId",
      headerName: "ID",
      width: 180,
      height: 50,
      headerClassName: "super-app-theme--header",
      editable: false,
      type: "string",
      minWidth: 180,
      flex: 1,
    },
    {
      field: "priority",
      headerName: "PRIORITY",
      width: 180,
      height: 50,
      headerClassName: "super-app-theme--header",
      editable: false,
      type: "string",
      minWidth: 180,
      flex: 1,
      renderCell: (params) => <StatusPill status={params.value} />,
    },
    {
      field: "status",
      width: 180,
      height: 50,
      headerName: "STATUS",
      headerClassName: "super-app-theme--header",
      editable: false,
      type: "string",
      minWidth: 180,
      flex: 1,
      renderCell: (params) => <StatusPill status={params.value} />,
    },
    {
      field: "actionRequired",
      headerName: "ACTION REQUIRED",
      headerClassName: "super-app-theme--header",
      editable: false,
      type: "string",
      width: 350,
      minWidth: 350,
      flex: 1,

      renderCell: (params) => (
        <div
          style={{
            whiteSpace: "normal",
            wordBreak: "break-word",
            paddingTop: "8px",
            paddingBottom: "8px",
            lineHeight: "1.4",
          }}
        >
          {params.value}
        </div>
      ),
    },

    {
      field: "elementAffected",
      width: 160,
      height: 50,
      headerName: "ELEMENT AFFECTED",
      headerClassName: "super-app-theme--header",
      editable: false,
      type: "string",
      minWidth: 160,
      flex: 1,
    },
    {
      field: "dueDate",
      width: 210,
      height: 50,
      headerName: "DUE DATE",
      headerClassName: "super-app-theme--header",
      editable: false,
      type: "string",
      minWidth: 210,
      flex: 1,
    },
    {
      field: "completedOn",
      width: 160,
      height: 50,
      headerName: "COMPLETED ON",
      headerClassName: "super-app-theme--header",
      editable: false,
      type: "string",
      minWidth: 160,
      flex: 1,
    },
    {
      field: "completedBy",
      width: 160,
      height: 50,
      headerName: "COMPLETED BY",
      headerClassName: "super-app-theme--header",
      editable: false,
      type: "string",
      minWidth: 160,
      flex: 1,
    },
    {
      field: "actionItemAssignedTo",
      headerName: "ASSIGNED TO",
      width: 180,
      height: 50,
      headerClassName: "super-app-theme--header",
      editable: false,
      type: "string",
      minWidth: 180,
      flex: 1,
    },
  ];

  const [toolbar, setToolBar] = useState({
    searchText: "",
    actionId: "",
    priority: "",
    status: "",
    dueDate: "",
    dueFrom: "",
    dueTo: "",
    propertyId: "",
    buildingId: "",
    pageSize: 100,
  });

  const TOOLBAR_INITIAL = {
    searchText: "",
    actionId: "",
    priority: "",
    status: "",
    dueDate: "",
    dueFrom: "",
    dueTo: "",
    propertyId: "",
    buildingId: "",
    pageSize: 100,
  };

  const isAnyFilterApplied =
    toolbar.searchText !== "" ||
    toolbar.actionId !== "" ||
    toolbar.priority !== "" ||
    toolbar.status !== "" ||
    toolbar.dueFrom !== "" ||
    toolbar.dueTo !== "" ||
    toolbar.propertyId !== "" ||
    toolbar.buildingId !== "";

  useEffect(() => {
    if (!clientObj?.clientId) return;

    const fetchPropertiesList = async () => {
      try {
        const response = await http.get(
          GET_PROPERTIES_LIST + `?clientId=${clientObj?.clientId}`,
        );
        if (response.status === 200) {
          console.log(response);
          setPropertiesList(response?.data);
          const flattenedList = response?.data.flatMap((property) => {
            // If no buildings, still return one row
            if (!property.buildings || property.buildings.length === 0) {
              return [
                {
                  propertyMasterId: property.propertyMasterId,
                  propertyName: property.name,
                  address: property.address,
                  latitude: property.latitude,
                  longitude: property.longitude,
                  status: property.status,
                  blockId: null,
                  blockName: null,
                  buildingNo: null,
                  buildingImage: null,
                },
              ];
            }

            // If buildings exist, create one row per building
            return property.buildings.map((building) => ({
              propertyMasterId: property.propertyMasterId,
              propertyName: property.name,
              address: property.address,
              latitude: property.latitude,
              longitude: property.longitude,
              status: property.status,
              blockId: building.blockId,
              blockName: building.blockName,
              buildingNo: building.buildingNo,
              buildingImage: building.buildingImage,
            }));
          });
          console.log("fl", flattenedList);
          setFlattenedProperties(flattenedList);

          const first = response?.data?.[0];
          setSelectedSite(first);
          setToolBar((prev) => ({
            ...prev,
            propertyId: "",
            buildingId: "",
          }));

          // Check for doorreferencenumber query parameter first (takes precedence)
          const queryParams = new URLSearchParams(location.search || "");
          const doorRefNumber =
            queryParams.get("doorreferencenumber") ||
            queryParams.get("doorReferenceNumber") ||
            queryParams.get("DoorReferenceNumber"); // Add PascalCase support

          if (doorRefNumber && doorRefNumber.trim()) {
            // Query parameter takes precedence - auto-fill and search
            const updatedToolbar = {
              ...TOOLBAR_INITIAL,
              searchText: doorRefNumber.trim(),
              propertyId: "",
              buildingId: "",
            };
            setToolBar(updatedToolbar);
            fetchProfileDetails(first, updatedToolbar);
            return;
          }

          // Otherwise, check localStorage
          const existing = localStorage.getItem(STORAGE_KEY);

          localStorage.removeItem(STORAGE_KEY);
          if (existing !== null) {
            const parsed = JSON.parse(existing);
            console.log("storage", parsed);
            setToolBar(parsed);
            fetchProfileDetails(first, parsed); // reload table
          } else {
            fetchProfileDetails(first);
          }
        }
      } catch (err) {
        console.log(err);
      }
    };

    fetchPropertiesList();
  }, [clientObj?.clientId, location.search]);

  const fetchProfileDetails = async (site, existingToolbar) => {
    try {
      setLoading(true);
      let toolbarvalues;
      if (existingToolbar) {
        toolbarvalues = existingToolbar;
      } else {
        toolbarvalues = toolbar;
      }
      const payload = {
        clientId: clientObj?.clientId,
        userId: userObj?.userId,
        // propertyMasterId:
        //   toolbar.propertyId === ""
        //     ? site?.propertyMasterId
        //     : toolbar.propertyId,
        // clientId: "BD44F9AC-6A4A-4073-866C-A8CF840C4176",
        // propertyMasterId:"AA8329DA-4687-4A73-8DD7-E0DF467011C7",
        propertyMasterId: toolbarvalues.propertyId?.trim() || null,
        buildingId: toolbarvalues.buildingId?.trim() || null,
        searchText:
          toolbarvalues.searchText === "" ? null : toolbarvalues.searchText,
        idSearch: toolbarvalues.actionId === "" ? null : toolbarvalues.actionId,
        priority: toolbarvalues.priority === "" ? null : toolbarvalues.priority,
        status: toolbarvalues.status === "" ? null : toolbarvalues.status,
        dueFrom: toolbarvalues.dueFrom === "" ? null : toolbarvalues.dueFrom,
        dueTo: toolbarvalues.dueTo === "" ? null : toolbarvalues.dueTo,
        pageNumber: 1,
        pageSize: toolbarvalues.pageSize,
      };

      const res = await http.post(GET_ACTION_DETAILS, payload);

      const data = res.data;
      setDash(data?.dashboard);
      if (data?.items?.length > 0) {
        // const actionIdRef = await fetchActionItemIdFromProperty(
        //   toolbar.propertyId === ""
        //     ? site?.propertyMasterId
        //     : toolbar.propertyId,
        //   data.items[0].inspectionReferenceNumber,
        // );
        // console.log(actionIdRef);

        const filteredItems = data.items.filter(
          (item) => item.status !== "Archive",
        );
        const mappedRows = filteredItems.map((item, index) => ({
          id: null || index,
          doorRefno: item.doorRefNumber,
          // actionId: actionIdRef.filter(
          //   (x) => x.id === item.complianceCheckMasterID
          // )[0].actionId,
          actionId: item.actionId,
          siteName: item.propertyName,
          buildingName: item.buildingName,
          buildingId: item.buildingId,
          address: item.propertyLocation,
          priority: item.priority,
          actionRequired: item.remediation,
          elementAffected: item.doorLocation,
          dueDate: item.dueDate
            ? new Date(item.dueDate).toLocaleDateString("en-GB", {
                day: "2-digit",
                month: "long",
                year: "numeric",
              })
            : "",
          completedOn: item.createdOn
            ? new Date(item.createdOn).toLocaleDateString("en-GB", {
                day: "2-digit",
                month: "long",
                year: "numeric",
              })
            : "",
          completedBy: item.createdBy,
          status: item.status || "Not Available",
          actionItemAssignedTo: item.actionItemAssignedTo || "",
          postalcode: item.postalCode,
          country: item.cityId,
          inspctiondate: item.inspectionDate
            ? new Date(item.inspectionDate).toLocaleDateString("en-GB", {
                day: "2-digit",
                month: "long",
                year: "numeric",
              })
            : "",
          inspectionby: item.inspectors,
          approveby: item.approvers,
          approvedon: item.approvalDate
            ? new Date(item.approvalDate).toLocaleDateString("en-GB", {
                day: "2-digit",
                month: "long",
                year: "numeric",
              })
            : "",

          compcheckid: item.complianceCheckID,
          inspdoorid: item.inspectedDoorId,
          comcheckmaster: item.complianceCheckMasterID,
          gaps: item.gaps,
        }));

        setRows(mappedRows);

        if (actionIdList && actionIdList.length === 0) {
          const uniqueIds = new Set(
            mappedRows?.map((item) => item && item.actionId).filter((id) => id), // remove null, undefined, empty
          );

          const actionIdRows = Array.from(uniqueIds).map((id) => ({
            actionId: id,
          }));

          const sorted = actionIdRows.sort((a, b) => {
            const numA = parseInt(a.actionId.split("-")[1], 10);
            const numB = parseInt(b.actionId.split("-")[1], 10);
            return numA - numB;
          });

          setActionidList(sorted);
        }
      } else {
        setRows([]);
      }
    } catch (err) {
      console.error(err);
      // setToastData({
      //   toastShow: true,
      //   toastType: "failure",
      //   toastString:
      //     err?.response?.data?.message ||
      //     err?.message ||
      //     "Something went wrong",
      // });
      setRows([]);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    const tmpbuildingNameList = [
      ...new Map(
        flattentedProperties
          ?.filter((item) =>
            toolbar.propertyId
              ? item.propertyMasterId === toolbar.propertyId &&
                item?.status?.toString().trim().toLowerCase() !== "archive" &&
                item?.blockName !== null
              : item?.status?.toString().trim().toLowerCase() !== "archive" &&
                item?.blockName !== null,
          )
          .map((item) => [item.blockName, item]) || [],
      ).values(),
    ];
    console.log(tmpbuildingNameList);
    
    setBuildingNameList(tmpbuildingNameList);
  }, [flattentedProperties, toolbar]);

  const fetchDownloadExcel = async (site, existingToolbar) => {
    if (!rows || rows.length === 0) {
      setToastData({
        toastShow: true,
        toastType: "failure",
        toastString: "No data to export",
      });
      return;
    }

    try {
      setLoading(true);

      const toolbarvalues = existingToolbar || toolbar;

      const payload = {
        clientId: clientObj?.clientId,
        userId: userObj?.userId,
        propertyMasterId: toolbarvalues.propertyId?.trim() || null,
        searchText: toolbarvalues.searchText || null,
        idSearch: toolbarvalues.actionId || null,
        priority: toolbarvalues.priority || null,
        status: toolbarvalues.status || null,
        dueFrom: toolbarvalues.dueFrom || null,
        dueTo: toolbarvalues.dueTo || null,
        pageNumber: 1,
        pageSize: toolbarvalues.pageSize,
      };

      const response = await http.post(DOWNLOAD_EXCEL_FILE, payload, {
        responseType: "blob",
      });

      const blob = new Blob([response.data], {
        type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
      });

      const contentDisposition = response.headers["content-disposition"];
      let fileName = "ActionItems.xlsx";

      if (contentDisposition) {
        const match = contentDisposition.match(
          /filename\*?=(?:UTF-8'')?([^;]+)/,
        );
        if (match && match[1]) {
          fileName = decodeURIComponent(match[1].replace(/"/g, ""));
        }
      }
      if (
        navigator.userAgent.includes("Safari") &&
        !navigator.userAgent.includes("Chrome")
      ) {
        const reader = new FileReader();

        reader.onloadend = () => {
          const link = document.createElement("a");
          link.href = reader.result;
          link.download = fileName;
          document.body.appendChild(link);
          link.click();
          link.remove();
        };

        reader.readAsDataURL(blob);
      } else {
        const url = window.URL.createObjectURL(blob);
        const link = document.createElement("a");
        link.href = url;
        link.setAttribute("download", fileName);
        document.body.appendChild(link);
        link.click();

        link.remove();
        window.URL.revokeObjectURL(url);
      }

      setToastData({
        toastShow: true,
        toastType: "success",
        toastString: "Excel file downloaded successfully.",
      });
    } catch (err) {
      console.error(err);
      setToastData({
        toastShow: true,
        toastType: "failure",
        toastString:
          err?.response?.data?.message ||
          err?.message ||
          "Failed to download Excel file",
      });
    } finally {
      setLoading(false);
    }
  };

  // const fetchActionItemIdFromProperty = async (
  //   propertyMasterId,
  //   inspectionReferenceNumber,
  // ) => {
  //   try {
  //     const response = await http.get(
  //       GET_PROPERTY_INFO_WITH_MASTER +
  //         propertyMasterId +
  //         "?InspectionReferenceNumber=" +
  //         inspectionReferenceNumber,
  //     );

  //     if (response.status == 200) {
  //       const mappedRows = response?.data?.doorComplainceCheckMasters?.map(
  //         (item) => ({
  //           id: item.doorComplainceCheckMasterId,
  //           actionId: item.actionItemId,
  //         }),
  //       );
  //       console.log(mappedRows)

  //     const sorted = mappedRows.sort((a, b) => {
  //       const numA = parseInt(a.actionId.split("-")[1], 10);
  //       const numB = parseInt(b.actionId.split("-")[1], 10);
  //       return numA - numB;
  //     });

  //       setActionidList(sorted);
  //       return mappedRows;
  //     }
  //   } catch (error) {
  //     console.error("Property API error:", error);
  //     return null;
  //   }
  // };
  const normalizeDate = (date) => {
    if (!date) return null;

    const d = date.toDate(); // IMPORTANT
    d.setHours(12, 0, 0, 0); // Noon prevents timezone shift
    return d;
  };

  return (
    <>
      <Header hideSidebar={hideSidebar} setHideSidebar={setHideSidebar} />
      <Toaster
        show={toastData.toastShow}
        toastType={toastData.toastType}
        title={toastData.toastString}
        theme={"dark"}
        position="top-center"
        closeButton={closeButton}
      />
      <LoadingComponent loading={loading} />
      {userObj && (
        <div className="dashboard_body_main">
          {hideSidebar ? (
            <Sidebar
              setHideSidebar={setHideSidebar}
              hideSidebar={hideSidebar}
            />
          ) : (
            <SidebarIcons
              setHideSidebar={setHideSidebar}
              hideSidebar={hideSidebar}
            />
          )}
          <div className="d-flex dashboard_body flex-column py-1 w-100 mt-2 ">
            <div className="col-12 col-sm-12 col-lg-12 mb-3">
              <div className="d-flex justify-content-between align-items-center w-100 mt-3">
                <h3 className="justifyStart fw-semibold mb-0">Actions Plan</h3>
              </div>

              <div
                className="card mt-4 p-3 rounded-4 mb-4 orange-box d-flex gap-3 flex-row align-items-center justify-content-between"
                style={{ height: "9.5rem" }}
              >
                <div className="card-body">
                  <div className="d-flex align-items-center justify-content-evenly text-center py-4">
                    <div>
                      <h1 className="mb-0" style={{ fontSize: "4rem" }}>
                        {dash?.totalOpenActions}
                      </h1>
                      <p className="fw-semibold mb-0">Total Actions</p>
                    </div>
                    <div className="col-6 col-sm-4 col-lg-2 mb-1">
                      <img src={dashlogo} alt="Inspector" height="100" />
                    </div>
                    <div>
                      <h1 className="mb-0" style={{ fontSize: "4rem" }}>
                        {dash?.criticalPriority}
                      </h1>
                      <p className="fw-semibold mb-0">Critical Priority</p>
                    </div>
                    <div>
                      <h1 className="mb-0" style={{ fontSize: "4rem" }}>
                        {dash?.highPriority}
                      </h1>
                      <p className="fw-semibold mb-0">High Priority</p>
                    </div>
                    <div>
                      <h1 className="mb-0" style={{ fontSize: "4rem" }}>
                        {dash?.mediumPriority}
                      </h1>
                      <p className="fw-semibold mb-0">Medium Priority</p>
                    </div>
                    <div>
                      <h1 className="mb-0" style={{ fontSize: "4rem" }}>
                        {dash?.lowPriority}
                      </h1>
                      <p className="fw-semibold mb-0">Low Priority</p>
                    </div>
                    <div>
                      <h1 className="mb-0" style={{ fontSize: "4rem" }}>
                        {dash?.overdueActions}
                      </h1>
                      <p className="fw-semibold mb-0">Overdue Actions</p>
                    </div>
                    {/* <div>
                      <h1 className="mb-0" style={{ fontSize: "4rem" }}>
                        {dash.pendingReview}
                      </h1>
                      <p className="fw-semibold mb-0">Pending Review</p>
                    </div> */}
                  </div>
                </div>
              </div>
              <div className="col-12 mb-3">
                <h3 className="fw-semibold  mb-0 text-start ">Door Surveys</h3>
                <div className="row py-3 align-items-center g-2">
                  <div className="col d-flex flex-wrap align-items-center gap-2">
                    <div className="custom_toolbar_search col-12 col-sm-6 col-md-2 d-flex align-items-center">
                      <img src={searchIcon} alt="search" className="me-2" />
                      <input
                        type="text"
                        className="form-control custom_toolbar_control"
                        placeholder="Search actions..."
                        value={toolbar.searchText}
                        onChange={(e) =>
                          setToolBar({ ...toolbar, searchText: e.target.value })
                        }

                        // onChange={(e) => {
                        //   const value = e.target.value;

                        //   setToolBar((prev) => ({
                        //     ...prev,
                        //     searchText: value,
                        //     propertyId: value ? "" : prev.propertyId,
                        //   }));

                        //   if (value) {
                        //     setSelectedSite(null);
                        //   }
                        // }}
                      />
                    </div>

                    <div className="col-12 col-sm-6 col-md-2">
                      <AutocompleteInput
                        // masterList={propertiesList}
                        masterList={
                          propertiesList?.filter(
                            (site) =>
                              site?.status?.toString().trim().toLowerCase() !==
                              "archive",
                          ) || []
                        }
                        getOptionLabel={(site) => site?.name || ""}
                        getOptionValue={(site) => site?.propertyMasterId || ""}
                        value={toolbar.propertyId}
                        onValueChange={(value, site) => {
                          setToolBar({ ...toolbar, propertyId: value || "" });
                          if (site) {
                            setSelectedSite(site);
                          }
                        }}
                        // onValueChange={(value, site) => {
                        //   setToolBar((prev) => ({
                        //     ...prev,
                        //     propertyId: value || "",
                        //     searchText: value ? "" : prev.searchText,
                        //   }));

                        //   if (value) {
                        //     setSelectedSite(site || null);
                        //   } else {
                        //     setSelectedSite(null);
                        //   }
                        // }}
                        placeholder="Site Name"
                        inputClassName="form-control custom_toolbar_control mt-1"
                        notFoundText="Site not found"
                      />
                    </div>

                    <div className="col-12 col-sm-6 col-md-2">
                      <AutocompleteInput
                        // masterList={propertiesList}
                        masterList={buildingNameList}
                        getOptionLabel={(site) => site?.blockName || ""}
                        getOptionValue={(site) => site?.blockId || ""}
                        value={toolbar.buildingId}
                        onValueChange={(value, site) => {
                          setToolBar({ ...toolbar, buildingId: value || "", propertyId: site?.propertyMasterId || "" });
                          if (site) {
                            setSelectedSite(site);
                          }
                        }}
                        placeholder="Building Name"
                        inputClassName="form-control custom_toolbar_control mt-1"
                        notFoundText="Building not found"
                      />
                    </div>

                    <div className="col-12 col-sm-6 col-md-1">
                      <AutocompleteInput
                        masterList={actionIdList}
                        getOptionLabel={(site) => site?.actionId || ""}
                        getOptionValue={(site) => site?.actionId || ""}
                        placeholder="ID"
                        inputClassName="form-control custom_toolbar_control mt-1"
                        notFoundText="ID not found"
                        value={toolbar.actionId}
                        onValueChange={(value) =>
                          setToolBar({ ...toolbar, actionId: value })
                        }
                      />
                      {/* <option value="">ID</option>
                        {actionIdList.length > 0 &&
                          actionIdList?.map((data) => (
                            <option key={data?.actionId} value={data?.actionId}>
                              {data.actionId}
                            </option>
                          ))}
                      </select> */}
                    </div>

                    <div
                      className="col-12 col-sm-6 "
                      style={{ width: "108px" }}
                    >
                      <select
                        className="form-select custom_toolbar_control"
                        value={toolbar.priority}
                        onChange={(e) =>
                          setToolBar({ ...toolbar, priority: e.target.value })
                        }
                      >
                        <option value="">Priority</option>
                        <option value="Critical">Critical</option>
                        <option value="High">High</option>
                        <option value="Medium">Medium</option>
                        <option value="Low">Low</option>
                      </select>
                    </div>

                    <div className="col-12 col-sm-6" style={{ width: "130px" }}>
                      <select
                        className="form-select custom_toolbar_control"
                        value={toolbar.status}
                        onChange={(e) =>
                          setToolBar({ ...toolbar, status: e.target.value })
                        }
                      >
                        <option value="">Status</option>
                        <option value="Completed">Completed</option>
                        <option value="Pending">Pending</option>
                      </select>
                    </div>

                    <div className="col-12 col-sm-6 col-md-1 datePicker mt-0">
                      <DatePicker
                        className=""
                        value={dateRange}
                        onChange={(range) => {
                          const [start, end] = range || [];
                          setDateRange(range || [null, null]);
                          setToolBar((prev) => ({
                            ...prev,
                            dueFrom: start ? normalizeDate(start) : null,
                            dueTo: end ? normalizeDate(end) : null,
                          }));
                        }}
                        range
                        format="DD-MM-YYYY"
                        placeholder="Select date range"
                        plugins={[
                          <Toolbar
                            key={1}
                            position="bottom"
                            sort={["deselect", "close", "today"]}
                          />,
                        ]}
                        style={{ width: "100%" }}
                      />
                    </div>
                    <button
                      type="button"
                      className="btn btn-dark"
                      onClick={() => fetchProfileDetails(selectedSite)}
                    >
                      <img src={actionSearchIcon}></img>
                    </button>

                    {isAnyFilterApplied && (
                      <button
                        className="btn btn-outline"
                        title="Clear Filters"
                        onClick={() => {
                          setToolBar({
                            searchText: "",
                            actionId: "",
                            priority: "",
                            status: "",
                            dueDate: "",
                            dueFrom: "",
                            dueTo: "",
                            propertyId: "",
                          });
                          setDateRange([null, null]);
                          fetchProfileDetails(selectedSite, TOOLBAR_INITIAL);
                        }}
                      >
                        <img src={closeicon}></img>
                      </button>
                    )}
                  </div>

                  <div className="col-auto d-flex align-items-center gap-3">
                    {/* <img
                      src={downloadlogo}
                      alt="download"
                      style={{ cursor: "pointer" }}
                    /> */}

                    {/* <button
                      type="button"
                      className="btn btn-dark"
                       
                      onClick={() => {
                        localStorage.setItem(
                          STORAGE_KEY,
                          JSON.stringify(toolbar),
                        );
                        setShowUpdateModal(true);
                      }}
                      disabled={selectedIds.length === 0 ? true : false}
                    >
                      <img src={actionUpdateIcon}></img>
                    </button> */}
                    {/* <span
                      title={"Update action items"}
                      style={{ display: "inline-block" }}
                    > */}
                    <Tooltip
                      title="Update action items"
                      arrow
                      slotProps={{
                        tooltip: {
                          sx: {
                            bgcolor: "#fff",
                            color: "#000",
                            fontSize: "12px",
                            boxShadow: "0px 2px 8px rgba(0,0,0,0.15)",
                          },
                        },
                        arrow: {
                          sx: {
                            color: "#fff",
                          },
                        },
                      }}
                    >
                      {" "}
                      <span>
                        <button
                          type="button"
                          className="btn btn-dark"
                          onClick={() => {
                            localStorage.setItem(
                              STORAGE_KEY,
                              JSON.stringify(toolbar),
                            );
                            setShowUpdateModal(true);
                          }}
                          disabled={selectedIds.length === 0}
                          style={{
                            pointerEvents:
                              selectedIds.length === 0 ? "none" : "auto",
                          }}
                        >
                          <img src={actionUpdateIcon} alt="Update" />
                        </button>
                        {/* </span> */}
                      </span>
                    </Tooltip>

                    {/* <Tooltip title="Export to excel" arrow> */}
                    <Tooltip
                      title="Export to excel"
                      arrow
                      slotProps={{
                        tooltip: {
                          sx: {
                            bgcolor: "#fff",
                            color: "#000",
                            fontSize: "12px",
                            boxShadow: "0px 2px 8px rgba(0,0,0,0.15)",
                          },
                        },
                        arrow: {
                          sx: {
                            color: "#fff",
                          },
                        },
                      }}
                    >
                      <span>
                        <button
                          type="button"
                          className="btn btn-outline"
                          // title="Export to excel"
                          onClick={() => fetchDownloadExcel(selectedSite)}
                        >
                          <img src={downloadIcon}></img>
                        </button>
                      </span>
                    </Tooltip>
                    {showUpdateModal && (
                      <UpdateActionPopUp
                        show={showUpdateModal}
                        headingText="Update Action(s)"
                        cancelText="Cancel"
                        submitText="Update"
                        selectedRows={selectedRows}
                        onCancel={() => {
                          setShowUpdateModal(false);
                        }}
                        onSuccess={() => {
                          setLoading(true);
                          const existing = localStorage.getItem(STORAGE_KEY);
                          console.log("storage", existing);
                          localStorage.removeItem(STORAGE_KEY);
                          if (existing !== null) {
                            const parsed = JSON.parse(existing);
                            setToolBar(parsed);

                            fetchProfileDetails(selectedSite, parsed); // reload table
                          }
                          setShowUpdateModal(false);
                        }}
                      />
                    )}
                  </div>
                </div>

                <div className="inspection-table pt-2">
                  <DynamicTable
                    columnsValue={tableColumns}
                    tableData={rows}
                    showSelectAll={true}
                    pageSize={10}
                    // rowHeight={90}
                    setSelectedIds={setSelectedIds}
                    disableRowSelectionOnClick
                    localeText={{
                      noRowsLabel: "No data found",
                    }}
                    module="actionPlan"
                    pageSizeOptions={[
                      100,
                      150,
                      200,
                      { value: -1, label: "All" },
                    ]}
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default ActionRemediation;
